// @ts-nocheck

class AiCartImageReplacer {
  constructor() {
    this.refreshTimer = null;
    this.requestController = null;
    this.observer = null;
    this.init();
  }

  init() {
    [
      'cart-update',
      'cart:update',
      'cart:updated',
      'product:added',
      'quantity-selector:update',
      'discount:update'
    ].forEach((eventName) => {
      document.addEventListener(eventName, () => this.refresh());
    });
    this.observeCartChanges();
    this.refresh();
  }

  observeCartChanges() {
    this.observer = new MutationObserver((mutations) => {
      const cartChanged = mutations.some((mutation) => {
        if (mutation.type !== 'childList') return false;
        return Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;
          return node.matches?.('.cart-item, .cart-items__table-row, cart-drawer, cart-drawer-items, cart-drawer-component, cart-items-component')
            || node.querySelector?.('.cart-item, .cart-items__table-row, cart-drawer, cart-drawer-items, cart-drawer-component, cart-items-component');
        });
      });
      if (cartChanged) this.refresh();
    });

    this.observer.observe(document.body, { childList: true, subtree: true });
  }

  refresh() {
    clearTimeout(this.refreshTimer);
    this.refreshTimer = setTimeout(() => this.replaceCartImages(), 120);
  }

  async getCart() {
    if (this.requestController) this.requestController.abort();
    this.requestController = new AbortController();
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      cache: 'no-store',
      signal: this.requestController.signal,
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  }

  async replaceCartImages() {
    try {
      const cart = await this.getCart();
      const layouts = this.getCartLayouts();

      layouts.forEach(({ root, rowSelector }) => {
        const rows = Array.from(root.querySelectorAll(rowSelector));
        rows.forEach((row, index) => {
          const item = cart.items[index];
          const watermarkUrl = item?.properties?.['Watermark Image URL'];
          if (!watermarkUrl) return;
          const image = row.querySelector('.cart-item__image, .cart-items__media-image');
          if (image) this.replaceImage(image, watermarkUrl);
        });
      });
    } catch (error) {
      if (error?.name !== 'AbortError') {
        console.error('Failed to replace cart images:', error);
      }
    }
  }

  getCartLayouts() {
    const layouts = [];
    [
      document.getElementById('CartDrawer-CartItems'),
      document.getElementById('main-cart-items')
    ].filter(Boolean).forEach((root) => layouts.push({ root, rowSelector: '.cart-item' }));

    const horizonComponents = Array.from(document.querySelectorAll('cart-drawer-component, cart-items-component'));
    if (horizonComponents.length) {
      horizonComponents.forEach((root) => layouts.push({ root, rowSelector: '.cart-items__table-row' }));
    } else {
      document.querySelectorAll('.cart-items__table').forEach((root) => {
        layouts.push({ root, rowSelector: '.cart-items__table-row' });
      });
    }

    return layouts;
  }

  replaceImage(image, watermarkUrl) {
    if (image.dataset.aiWatermarkUrl === watermarkUrl) return;
    if (!image.dataset.originalSrc) image.dataset.originalSrc = image.currentSrc || image.src;

    const preload = new Image();
    preload.onload = () => {
      image.src = watermarkUrl;
      image.srcset = watermarkUrl;
      image.dataset.aiWatermarkUrl = watermarkUrl;
      image.classList.add('ai-watermark-image');
    };
    preload.onerror = () => console.error('AI cart image failed to load:', watermarkUrl);
    preload.src = watermarkUrl;
  }
}

const style = document.createElement('style');
style.textContent = '.ai-watermark-image{transition:opacity .3s ease;object-fit:cover}';
document.head.appendChild(style);

window.aiCartImageReplacer = new AiCartImageReplacer();
